class Constants {
  static ACCESS_TOKEN = "accessToken";
  static REFRESH_TOKEN = "refreshToken";
  static EXCHANGE_CODE = "code";
  static SKILLS_ID = "skillsID";
  static LANGUAGE = "language";
  static LANG = "lang";
  static META_FBP = "_fbp";
  static META_FBC = "_fbc";
  static APPS_FLYER_ID = "afUserId";
  static DEVICE_ID = "device_unique_id";
  static BUILD_VERSION = "build_version";
  static COUNTRY_CODE = "country_code";
  static COUNTRY = "country";
  static APP_STORE_QUERY_PARAM = "appStore";
}

export default Constants;
